import { type FormInstance } from "antd/lib/form"
import { store } from "~Shared/store"
import { type RootState } from "~Shared/store/rootState.interface"

export const FormService = {
    getFormAndReduxValues: (reduxKey: keyof RootState, formInstance: FormInstance, formIsArray = true) => {
        const formValues = formIsArray ? formInstance.getFieldValue([reduxKey]) : [formInstance.getFieldsValue()]
        const existingValuesRaw: Array<any> = store.getState()[reduxKey].items

        if (!existingValuesRaw) {
            throw new Error(`Redux value ${reduxKey}.items is not available`)
        }

        return {
            formValues,
            existingValuesRaw,
        }
    },
}
